export default class Scroll {

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            window.addEventListener('scroll', (ev) => {
                this.handleOfferButton();
                this.handleReveal(false);
            });

            setTimeout(() => {
                this.handleReveal(true);
            }, 300);

            this.handleOfferButton();
        });

    }


    handleOfferButton() {
        const offer = document.querySelector('header .offer');

        if (window.scrollY > 0) {
            offer.classList.remove('ghost');
            offer.classList.add('white');
        } else {
            if (!document.body.classList.contains('white-bg')) {
                offer.classList.remove('white');
                offer.classList.add('ghost');
            }
        }
    }

    //handle animations
    handleReveal(init) {
        const reveals = document.querySelectorAll('.reveal');

        let windowY = window.scrollY + window.innerHeight;
        reveals.forEach((reveal, i) => {
            let revealOffset = reveal.getBoundingClientRect().top + reveal.ownerDocument.defaultView.pageYOffset;
            let timeout = reveal.dataset.timeout ? parseInt(reveal.dataset.timeout) : 1;

            if (init) {
                timeout = 1 + timeout;
            }

            if (windowY > revealOffset) {
                setTimeout(() => {
                    reveal.classList.add('load');
                }, 300 * timeout);
            }
        });
    }


    //helper functions
    checkCollision(elm1, elm2) {
        var elm1Rect = elm1.getBoundingClientRect();
        var elm2Rect = elm2.getBoundingClientRect();

        return (elm1Rect.bottom > elm2Rect.top &&
            elm1Rect.top < elm2Rect.bottom);
    }

    checkCollisionByOffset(offset, element) {
        return (offset + 150 >= element.offsetTop &&
            offset + 150 <= element.offsetTop + element.offsetHeight);
    }
}
